import React, { Component } from "react";

// import UI components
import { Row, Col, Button, FormGroup } from "reactstrap";
import { Formik, Form, Field } from "formik";
import Switch from "react-switch";
import CustomisedModal from "components/Application/CustomisedModal";

// import form validator
import SimpleReactValidator from "simple-react-validator";

// import custom validator
import {
  lessThanFileSizeValidator,
  fileTypeValidator,
} from "helpers/customValidator";

// import constants
import { SUBMIT, UPDATE, SUCCESS, DANGER } from "constants/commonConstants";
import { IMAGE_FILE_TYPE } from "helpers/constants";

import { fileCompress, filePreview } from "helpers/generalUtils";

import {
  getCategoryListRequest,
  updateCategoryStatusByCategoryIdRequest,
  addCategoryRequest,
  updateCategoryByCategoryIdRequest,
} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import { toastrMessage } from "helpers/messageHelper";

import { jsonToFormData } from "helpers/axiosRequestData";
import { makeCategorySelectField } from "store/Masters/Category/selector";
import { createStructuredSelector } from "reselect";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";

class CategoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operationType: SUBMIT,
      categoryData: categoryDataInitialState(),
      imagePreview: null,
    };

    this.validator = new SimpleReactValidator({
      validators: Object.assign(
        lessThanFileSizeValidator(),
        fileTypeValidator()
      ),
    });
  }

  resetForm = (closeModal) => {
    this.setState({
      categoryData: categoryDataInitialState(),
      imagePreview: null,
      operationType: SUBMIT,
    });
    this.validator.hideMessages();

    if (closeModal) {
      this.props.closeModal();
    }
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.categoryApiResponse &&
      this.props.categoryApiResponse !== nextprops.categoryApiResponse
    ) {
      if (nextprops.categoryApiResponse.isSuccessResponse) {
        this.props.getCategoryListRequest();
        toastrMessage(nextprops.categoryApiResponse.responseMessage, SUCCESS);
        this.resetForm(true);
      } else if (!nextprops.categoryApiResponse.isSuccessResponse) {
        toastrMessage(nextprops.categoryApiResponse.responseMessage, DANGER);
      }
    }

    if (
      nextprops.categoryRecord &&
      this.props.categoryRecord !== nextprops.categoryRecord
    ) {
      if (nextprops.categoryRecord.categoryId) {
        this.setState({
          categoryData: nextprops.categoryRecord,
          operationType: UPDATE,
          imagePreview: nextprops.categoryRecord.categoryImageUrl,
        });
      } else {
        this.resetForm(false);
      }
    }
  }

  handleFilePreview = async (event, setFieldValue) => {
    // check if any one file is selected by user
    if (event.target.files.length > 0) {
      let file = event.target.files[0];

      await setFieldValue("categoryImage", file);

      if (this.validator.fieldValid("categoryImage")) {
        try {
          let response = await fileCompress(file);
          await setFieldValue("categoryImage", response);
          response = await filePreview(response);

          this.setState({ imagePreview: response });
        } catch (error) {
          this.setState({ imagePreview: null });
          setFieldValue("categoryImage", "");
        }
      } else {
        this.setState({ imagePreview: null });
      }
    }
  };

  formSubmit = async (val) => {
    const values = {
      ...val
    }
    if (this.validator.allValid()) {
      // values.categoryImage = ""
      this.setState({ categoryData: values });
      if (this.state.operationType === UPDATE) {
        values.IsImageChanged = values.categoryImage ? true : false;
        const data = jsonToFormData(values);
        this.props.updateCategoryByCategoryIdRequest(values.categoryId, data);
      } else {
        values.categoryType = 1;
        const data = jsonToFormData(values);
        this.props.addCategoryRequest(data);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-lg"
          isModalOpen={this.props.formDialog}
          modalTitle="Category"
          onModalDismiss={() => this.resetForm(true)}
        >
          <Formik
            initialValues={this.state.categoryData}
            enableReinitialize={true}
            onSubmit={this.formSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Row>
                  <Col lg="12">
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Category Name</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="categoryName"
                          type="text"
                          className="form-control"
                          autoFocus
                        ></Field>
                        {this.validator.message(
                          "categoryName",
                          values.categoryName,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Has Subcategory</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Switch
                          className="switch-sm"
                          onColor={primaryColor}
                          offColor={secondaryColor}
                          onChange={() =>
                            setFieldValue(
                              "hasSubCategory",
                              !values.hasSubCategory
                            )
                          }
                          checked={values.hasSubCategory}
                        />
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Category Sequence</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="categorySeq"
                          type="number"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "Category Sequence",
                          values.categorySeq,
                          "required|numeric|min:1,num"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Category Image</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            name="categoryImage"
                            accept="image/*"
                            onClick={(e) => (e.target.value = null)}
                            id="customFile"
                            onChange={(event) =>
                              this.handleFilePreview(event, setFieldValue)
                            }
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="customFile"
                          >
                            {values.categoryImage
                              ? values.categoryImage.name
                              : "Choose file"}
                          </label>
                        </div>
                        {this.validator.message(
                          "categoryImage",
                          values.categoryImage,
                          (this.state.operationType === SUBMIT
                            ? "required|"
                            : "") +
                            `lessThanFileSize:5242880|fileType:${IMAGE_FILE_TYPE}`
                        )}
                      </Col>
                    </Row>

                    {this.state.imagePreview && (
                      <Row className="form-group">
                        <Col sm="4" lg="3"></Col>
                        <Col sm="8" lg="5">
                          <img
                            className="img-thumbnail"
                            alt={values.categoryName}
                            width="200"
                            src={this.state.imagePreview}
                            data-holder-rendered="true"
                          />
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-0 text-right">
                      <div>
                        <Button type="submit" color="primary" className="mr-1">
                          {this.state.operationType}
                        </Button>

                        <Button
                          type="reset"
                          color="secondary"
                          onClick={() => this.resetForm(false)}
                        >
                          Reset
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  categoryApiResponse: makeCategorySelectField("categoryApiResponse"),
});

const withConnect = connect(mapStatetoProps, {
  getCategoryListRequest,
  updateCategoryStatusByCategoryIdRequest,
  addCategoryRequest,
  updateCategoryByCategoryIdRequest,
});

export default compose(withConnect, withRouter)(CategoryForm);
//export default withRouter(withConnect)(Index);

function categoryDataInitialState() {
  return {
    categoryName: "",
    categoryImage: "",
    hasSubCategory: false,
    categorySeq: "",
  };
}
